import { CaretDown } from 'phosphor-icons';

export const SearchSelect = ({
  label,
  testId,
  currentValue,
  handleChange,
  children,
  id,
}: React.PropsWithChildren<{
  label: string;
  testId: string;
  currentValue: string | number;
  handleChange: (value: string) => void;
  id?: string;
}>) => {
  return (
    <label>
      <div className="tiny-text mb-2 text-grey-600">{label}</div>
      <div className="relative">
        <select
          data-test={testId}
          className="focus-outline tiny-text h-10 w-full cursor-pointer appearance-none rounded-lg border border-grey-400 bg-grey-100 pl-3 pr-6 font-medium text-grey-600 hover:text-grey-700 focus:bg-white focus:text-grey-700 md:w-auto"
          value={currentValue}
          onChange={(e) => handleChange(e.target.value)}
          id={id}
        >
          {children}
        </select>
        <div className="pointer-events-none absolute right-2 top-0 flex h-full items-center justify-center">
          <CaretDown size={15} className="pointer-events-none text-grey-600" />
        </div>
      </div>
    </label>
  );
};
